import { FunctionComponent, memo } from "react";
import { IProps } from "./select-user.types";
import { SelectField } from "@edgetier/select";
import useUsers from "hooks-for/users/use-users";
import { IUser } from "@edgetier/watchtower-types";
import "./select-user.scss";

/**
 * Filter for users.
 * @param props.name        Field name.
 * @param props.parameters  Parameters to send along with the request for users.
 * @returns          users select.
 */
const SelectUser: FunctionComponent<IProps> = ({ name = "userId", ...otherProps }) => {
    const { data: users, isLoading } = useUsers();

    return (
        <SelectField<IUser, string>
            description="user"
            getLabel={({ firstName, surname }) => `${firstName} ${surname}`}
            getValue={({ userId }) => userId}
            isLoading={isLoading}
            items={users || []}
            name={name}
            {...otherProps}
        >
            {({ firstName, surname }) => (
                <>
                    {firstName} {surname}
                </>
            )}
        </SelectField>
    );
};

export default memo(SelectUser);
